import { atom } from 'recoil'

export type UserAtomType = {
  role: string
}

const DEFAULT_STATE = {
  role: '',
}

export const userAtom = atom<UserAtomType>({
  key: 'userState',
  default: DEFAULT_STATE,
})
